import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Icon from "react-bootstrap-icons";
import ReactS3Ultra from '../../../Utils/ReactS3Ultra';
import Select from "react-select";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getAllCategories } from '../../Common/Categories';
import ButtonComponent from '../../Common/Button/ButtonComponent';
import AudioTab from '../../Common/langugageToggle/AudioTab';
import { typeList } from '../../../Utils/GlobalConfigs';
import moment from 'moment';
import ChromeTab from '../../Common/langugageToggle/ChromeTab';
import useGetPageList from '../../Common/Reuse/useGetPageList';
import useGetMoodList from '../../Common/Reuse/useGetMoodList';

const EditArticle = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate()

  // call custom hook for page title
  const { pageData } = useGetPageList();
  const { moodData } = useGetMoodList();

  const userState = useSelector((state) => state?.cmsLogin?.userData.data);
  const getData = useSelector(state => state?.categories?.categoryList?.data);
  const article = location.state.article;

  // state for input field
  const [title, setTitle] = useState(article?.title || "");
  const [titleMr, setTitleMr] = useState(article?.titleLang?.mr || "")
  const [titleHn, setTitleHn] = useState(article?.titleLang?.hin || "")
  const [source, setSource] = useState(article?.source || "");
  const [imageURL, setImageURL] = useState(article?.imageURL || "");
  const [type, setType] = useState({ label: article?.type, value: article?.type } || "");
  const [tagcategories, setTagCategories] = useState({ label: article?.tagsCategory?.[0], value: article?.tagsCategory?.[0] } || "");
  const [bannerImages, setBannerImages] = useState(article?.bigImageURL || "");
  const [fileEventBanner, setFileEventBanner] = useState('');
  const [tags, setTags] = useState(article?.tags?.map((itm) => ({ label: itm, value: itm })) || "");
  const [contentURLs, setContentURLs] = useState(article?.contentURL?.map((itm) => ({ label: itm, value: itm })) || "");
  const [shoppee, setShoppee] = useState(article?.shoppee?.map((itm) => ({ label: itm, value: itm })) || "");
  const [categoryTypes, setCategoryTypes] = useState({ label: article?.contentCategory, value: article?.contentCategory } || "")
  const [description, setDescription] = useState(article?.descriptionLang?.en || "");
  const [descriptionMr, setDescriptionMr] = useState(article?.descriptionLang.mr || "");
  const [descriptionHn, setDescriptionHn] = useState(article?.descriptionLang.hin || "");
  const [shortdescription, setShortDescription] = useState(article?.shortDescriptionLang?.en || "");
  const [shortdescriptionMr, setShortDescriptionMr] = useState(article?.shortDescriptionLang?.mr || "");
  const [shortdescriptionHn, setShortDescriptionHn] = useState(article?.shortDescriptionLang?.hin || "");
  const [error, setErrors] = useState({});
  const [tagCategoryList, setTagCategoriesList] = useState([]);
  const [TagList, setTagList] = useState([]);
  const [contentList, setContentList] = useState([]);
  const [ShopeeList, setShopeeList] = useState([]);
  const [mood, setMood] = useState(article?.moods?.map(moodItem => ({ label: moodItem, value: moodItem })) || [])
  const [audioURL, setAudioURL] = useState(article?.audioLang?.en || "");
  const [audioURLMr, setAudioURLMr] = useState(article?.audioLang?.mr || "");
  const [audioURLHn, setAudioURLHn] = useState(article?.audioLang?.hin || "");
  const [loader, setLoader] = useState(false);
  const [fileEvent, setFileEvent] = useState('');
  const [publishdate, setPublishDate] = useState((moment(article?.toPublishDate)).format('YYYY-MM-DD') || "")
  const [pageTitle, setpageTitle] = useState({ label: article?.pageName, value: article?.pageId, Lang: article?.pageNameLang } || "")
  const [author, setAuthor] = useState(article?.author || "");


  const OptionShopee = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  useEffect(() => {
    getTagCategoryList()
    getContentList()
    getShopeeList()
    getTagList()
    dispatch(getAllCategories({ payload: { categoryType: "feed" }, token: userState.token }))
  }, [])

  useEffect(() => {
    if (tagcategories !== "") {
      getTagList();
    }
  }, [tagcategories]);

  const getTagCategoryList = async () => {
    await fetch(process.env.REACT_APP_BASE_URL + "/cms/getAllTagCat", {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
    }).then((res) => res.json())
      .then((response) => {
        if (response.status === 200) {
          let arr = [];
          response?.data?.map((item) => {
            arr.push({
              ...item,
              label: item.tagCategoryName,
              value: item.tagCategoryName,
            });
          });
          setTagCategoriesList(arr);
        } else {
          setTagCategoriesList([]);
        }
      }).catch((error) => {
        console.log("error", error);
      })
  };

  // get category data
  const getArticleCategory = getData?.data !== undefined && getData?.data !== null && getData?.data?.length > 0 ?
    getData.data.map((itm) => {
      return ({ label: itm.tagCategoryName, value: itm.tagCategoryName })
      // return ({ label: itm.categoryName, value: itm.categoryName })
    }) : []

  // content url list
  const getContentList = async () => {
    await fetch(process.env.REACT_APP_BASE_URL + "/cms/getAllContents", {
      method: "POST",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let arr = [];
            response.data.map((item) => {
              arr.push({
                ...item,
                label: item.title,
                value: item.title,
              });
            });
            setContentList(arr);
          }
        }
      }).catch((error) => {
        console.log("error", error);
      })
  };

  // Shopee URL list
  const getShopeeList = async () => {
    await fetch(process.env.REACT_APP_BASE_URL + "/cms/getAllShoppees", {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
    })
      .then((res) => res.json())
      .then((response) => {
        if (response?.data.length > 0) {
          let arr = [];
          response.data.map((item) => {
            arr.push({
              ...item,
              label: item.name,
              value: item.name,
            });
          });
          setShopeeList(arr);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
  };

  // Tag list
  const getTagList = async () => {
    await fetch(process.env.REACT_APP_BASE_URL + '/cms/getAllTags2',
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
        body: JSON.stringify({ tagCategory: tagcategories.value })
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response?.status === 200) {
          let arr = [];
          response.data.map((item) => {
            arr.push({
              ...item,
              label: item.tag,
              value: item.tag,
            });
          });
          setTagList(arr);
        } else {
          setTagList([]);
        }
      });
  };


  const handleChangeContent = (selected) => {
    setContentURLs(selected);
  };

  const handleChangeShopee = (selected) => {
    setShoppee(selected);
  };

  // for validation
  const validate = () => {
    let newErrors = {};

    if (!title) {
      newErrors.title = "*Title is Required";
    }

    if (!titleMr) {
      newErrors.titleMr = "*Title in Marathi is Required";
    }

    // if (!pageTitle) {
    //   newErrors.pageTitle = "*Page Title is Required";
    // }


    if (!imageURL) {
      newErrors.imageURL = "*At least one Image is Required";
    }

    if (!bannerImages) {
      newErrors.bannerImages = "*Select Atleast one Banner Images";
    }

    if (!tagcategories) {
      newErrors.tagcategories = "*Please Select Tag category";
    }

    if (!type) {
      newErrors.type = "*Please Select Article Type";
    }

    if (shoppee.length === 0) {
      newErrors.shoppee = "*At least Select one Shoppe for Article";
    }

    if (!categoryTypes) {
      newErrors.categoryTypes = "*Please Select Category Type";
    }

    if (tags.length === 0) {
      newErrors.tags = "*At least Select one Tag for Article";
    }
    if (mood.length === 0) {
      newErrors.mood = "*Required Field";
    }
    if (!publishdate) {
      newErrors.publishdate = "*Required field"
    }

    // if ((!audioURL) ||
    //   (!audioURLMr)
    //   // ||(!audioURLHn) ||
    // ) {
    //   newErrors.audio = "* Audio in English and Marathi are required";
    // }


    if ((!shortdescriptionMr || shortdescriptionMr.trim() === '<p><br></p>') ||
      (!descriptionMr || descriptionMr.trim() === '<p><br></p>') ||
      (!shortdescription || shortdescription.trim() === '<p><br></p>') ||
      (!description || description.trim() === '<p><br></p>'))
    //  ||(!shortdescriptionHn || shortdescriptionHn.trim() === '<p><br></p>') ||
    //     (!descriptionHn || descriptionHn.trim() === '<p><br></p>')) 
    {
      newErrors.description = "*Both short and full descriptions in English and Marathi are required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleReactS3UltraRes = (url) => {
    setImageURL(url);
  }

  const handleReactS3UltraResBanner = (url) => {
    setBannerImages(url)
  }


  // for edit article data
  const editArticle = async (status) => {
    const isValid = validate();
    if (!isValid) return;
    setLoader(true);
    if (isValid) {
      let payload = {
        articleId: article?.articleId,
        title: title,
        titleLang: { en: title, mr: titleMr, hin: titleHn },
        description: descriptionMr,
        descriptionLang: { en: description, mr: descriptionMr, hin: descriptionHn },
        shortDescription: shortdescriptionMr,
        shortDescriptionLang: { en: shortdescription, mr: shortdescriptionMr, hin: shortdescriptionHn },
        imageURL: imageURL,
        bigImageURL: bannerImages,
        tagsCategory: tagcategories?.value,
        categories: tagcategories.label,
        type: type.label,
        source: source,
        contentId: contentURLs.map((item) => item.contentId),
        contentURL: contentURLs.map((item) => item.label),
        shoppeeId: shoppee.map((item) => item.Id),
        shoppee: shoppee.map((item) => item.label),
        priorityNo: 100,
        tags: tags.map((item) => item.label),
        tagsId: tags.map((item) => item.Id),
        moods: mood.map((item) => item?.label),
        moodId: mood.map((item) => item?.value),
        isHome: true,
        contentCategory: categoryTypes.value,
        audio: audioURLMr,
        audioLang: { en: audioURL, mr: audioURLMr, hin: audioURLHn },
        createdById: userState.user.name ? userState.user.name : "admin",
        updatedById: userState?.user?.userId,
        toPublishDate: publishdate,
        isPublish: status,
        pageId: pageTitle?.value ? pageTitle?.value : "",
        pageName: pageTitle?.label ? pageTitle?.label : "",
        pageNameLang: pageTitle?.Lang,
        author: author,
      };

      await fetch(process.env.REACT_APP_BASE_URL + "/article/updateArticle", {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.message === "Updated Successfully") {
            toast.success("Article updated Successfully !")
            navigate("/dashboard/articleList", { state: { updatedArticleId: article?.articleId } })
            setLoader(false)
          }
        })
        .catch((error) => {
          setLoader(false)
          console.log("Error", error);
        })
    }
  }

  return (
    <>
      <div className="outletPadding">
        <Row>
          <Button className="backBtn w-auto" onClick={() => navigate(-1)}>
            <Icon.ArrowLeft className="me-1" />Back
          </Button>
        </Row>

        <h3 className='text-center d-flex justify-content-center align-items-center'>
          <Icon.ChatQuote size={20} className='me-2' />Edit Article
        </h3>

        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Title in English<span>*</span></Form.Label>
              <Form.Control
                placeholder="Enter Title"
                value={title}
                onChange={(e) => {
                  if (
                    !e.target.value.match(
                      /[\u0900-\u097F]/
                    ) &&
                    e.target.value.trim()
                  ) {
                    setTitle(e.target.value);
                  } else if (e.target.value.length === 0) {
                    setTitle(e.target.value);
                  }
                }}
              />
              {error.title && <p className="error">{error.title}</p>}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Title in Marathi<span>*</span></Form.Label>
              <Form.Control
                placeholder="शीर्षक प्रविष्ट करा"
                value={titleMr}
                onChange={(e) => {
                  const marathiRegex = /^[\u0900-\u097F\s@#$&%!~=^_:()/\/{}\[\]|/*./\//\-/?<>,;`'""]+$/;
                  if (marathiRegex.test(e.target.value) && e.target.value.trim()) {
                    setTitleMr(e.target.value);
                  } else if (e.target.value.length === 0) {
                    setTitleMr(e.target.value);
                  }
                }}
              />
              {error.titleMr && <p className="error">{error.titleMr}</p>}
            </Form.Group>
          </Col>

          <Col md={4} className='off'>
            <Form.Group className="mb-3">
              <Form.Label>Title in Hindi</Form.Label>
              <Form.Control
                placeholder="शीर्षक दर्ज करें"
                value={titleHn}
                onChange={(e) => {
                  const marathiRegex = /^[\u0900-\u097F\s@#$&%!~=^_:()/\/{}\[\]|/*./\//\-/?<>,;`'""]+$/;
                  if (marathiRegex.test(e.target.value) && e.target.value.trim()) {
                    setTitleHn(e.target.value);
                  } else if (e.target.value.length === 0) {
                    setTitleHn(e.target.value);
                  }
                }}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Add Source</Form.Label>
              <Form.Control
                placeholder="Enter source"
                value={source}
                onChange={(e) => {
                  setSource(e.target.value);
                }}
              />
              {/* {error.source && <p className="error">{error.source}</p>} */}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Image<span>*</span></Form.Label> <br />
              <>
                {!imageURL &&
                  <>
                    <label htmlFor="fileInput" id="uploadBtn">
                      <Icon.CloudArrowUp size={20} className="me-2" />
                      Upload Image
                    </label>

                    <input
                      accept="image/jpeg, image/png, image/gif"
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      onChange={(event) => setFileEvent(event)}
                    />
                    <p id='imgNote'>Recommanded image resolution - 4/5 (1080*1350 px)</p>
                  </>}
                {error.imageURL && (<p className="errMsg">{error.imageURL}</p>)}
                <br />
                {imageURL ? (
                  <div className="d-flex" style={{ flexWrap: "wrap" }}>
                    <Card className="uploadedFile me-3">
                      <img src={imageURL} style={{ width: 60, height: 60 }} className='mx-auto' />
                      <Icon.XCircleFill className='removeIcon' size={18}
                        onClick={() => setImageURL("")} />

                    </Card>
                  </div>
                ) : null}
              </>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3" id="img">
              <Form.Label>Banner Image<span>*</span></Form.Label> <br />
              {!bannerImages ?
                <>
                  <label htmlFor="bannerInput" id="uploadBtn">
                    <Icon.CloudArrowUp size={20} className="me-2" />Upload Image
                  </label>
                  <input
                    type="file"
                    accept="image/jpeg, image/png, image/gif"
                    id="bannerInput"
                    style={{ display: "none" }}
                    onChange={(event) => setFileEventBanner(event)} />
                  <p id='imgNote'>Recommanded image resolution - 4/5 (1080*1350 px)</p>
                  {error.bannerImages && <p className="errMsg">{error.bannerImages}</p>}
                </>
                :
                <div className="d-flex" style={{ flexWrap: "wrap" }}>
                  <Card className="uploadedFile m-1">
                    <img src={bannerImages} style={{ width: 60, height: 60 }} className='mx-auto' />
                    <Icon.XCircleFill className='removeIcon' size={18}
                      onClick={() => setBannerImages('')} />
                  </Card>
                </div>
              }
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Type<span>*</span></Form.Label>
              <Select
                isMulti={false}
                options={typeList}
                value={type}
                onChange={(option) => {
                  setType(option);
                  // setRoleErr(false);
                }}
              />
              {error.type && <p className="error">{error.type}</p>}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Tag category<span>*</span></Form.Label>
              <Select
                isMulti={false}
                options={tagCategoryList}
                value={tagcategories}
                onChange={(option) => {
                  setTagCategories(option);
                  setTags([])
                }}
              />
              {error.tagcategories && <p className="error">{error.tagcategories}</p>}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Add Tags Name<span>*</span></Form.Label>
              <Select isDisabled={tagcategories === ""}
                isMulti={true}
                options={TagList}
                isSearchable={true}
                value={tags}
                closeMenuOnSelect={false}
                placeholder={<div style={{ fontSize: '15px' }}>Select Tags</div>}
                onChange={(option) => { setTags(option); }} />
              {error.tags && <p className="error">{error.tags}</p>}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Page</Form.Label>
              <Select
                isMulti={false}
                options={pageData}
                value={pageTitle}
                onChange={(option) => {
                  setpageTitle(option);
                }}
              />
              {/* {error.pageTitle && (<p className="error">{error.pageTitle}</p>)} */}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Select Content URL</Form.Label>
              <ReactSelect
                options={contentList}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                // components={{
                //   Option: OptionContent,
                // }}
                onChange={handleChangeContent}
                allowSelectAll={true}
                value={contentURLs}
              />

            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Select Shopee<span>*</span></Form.Label>
              <ReactSelect
                options={ShopeeList}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option: OptionShopee,
                }}
                onChange={handleChangeShopee}
                allowSelectAll={true}
                value={shoppee}
              />
              {error.shoppee && <p className="error">{error.shoppee}</p>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Feed Category<span>*</span></Form.Label>
              <Select
                value={categoryTypes}
                options={getArticleCategory}
                onChange={(option) => setCategoryTypes(option)}
              />
              {error.categoryTypes && <p className="error">{error.categoryTypes}</p>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Mood<span>*</span></Form.Label>
              <Select
                isMulti={true}
                isSearchable={true}
                placeholder="Select mood"
                value={mood}
                onChange={(option) => setMood(option)}
                options={moodData}
              />
              {error.mood && <div className="error">{error.mood}</div>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Author Name</Form.Label>
              <Form.Control
                placeholder="Enter Author name"
                value={author}
                onChange={(e) => {
                  if (
                    !e.target.value.match(
                      /[\u0900-\u097F]/
                    ) &&
                    e.target.value.trim()
                  ) {
                    setAuthor(e.target.value);
                  } else if (e.target.value.length === 0) {
                    setAuthor(e.target.value);
                  }
                }}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Publish Date<span>*</span></Form.Label>
              <Form.Control
                className=""
                type="date"
                name="publish Date"
                value={publishdate}
                min={new Date().toISOString().split("T")[0]}
                onKeyDown={(event) => event.preventDefault()}
                onChange={(e) => setPublishDate(e.target.value)}
              />
              {error.publishdate && <p className="errMsg">{error.publishdate}</p>}
            </Form.Group>
          </Col>
        </Row>

        {/* for audio file */}
        <AudioTab
          audioURLMr={audioURLMr}
          setAudioURLMr={setAudioURLMr}
          audioURL={audioURL}
          setAudioURL={setAudioURL}
          audioURLHn={audioURLHn}
          setAudioURLHn={setAudioURLHn}
        />
        {error.audio && (
          <p className="errMsg mt-1">{error.audio}</p>
        )}

        <Row>
          {/* for description  */}
          <ChromeTab
            shortdescriptionMr={shortdescriptionMr}
            setShortDescriptionMr={setShortDescriptionMr}
            descriptionMr={descriptionMr}
            setDescriptionMr={setDescriptionMr}
            shortdescription={shortdescription}
            setShortDescription={setShortDescription}
            descriptionEn={description}
            setDescriptionEn={setDescription}
            shortdescriptionHn={shortdescriptionHn}
            setShortDescriptionHn={setShortDescriptionHn}
            descriptionHn={descriptionHn}
            setDescriptionHn={setDescriptionHn}
          />

        </Row>
        {error.description && (
          <p className="errMsg mt-1">{error.description}</p>
        )}

        {loader ? (
          <Spinner variant="primary" />
        ) : (
          <>
            <ButtonComponent
              onSave={editArticle}
              onSaveAndPublish={editArticle}
              saveLabel="Update"
              savePublish="Update & Publish"
            />
          </>
        )}
        {
          fileEvent &&
          <ReactS3Ultra fileEvent={fileEvent} fileType={process.env.REACT_APP_IMAGE}
            directory="articleImages" onFileUpload={handleReactS3UltraRes} type={4 / 5} />
        }

        {
          fileEventBanner &&
          <ReactS3Ultra fileEvent={fileEventBanner} fileType={process.env.REACT_APP_IMAGE}
            directory="articleBanners" onFileUpload={handleReactS3UltraResBanner} type={4 / 5} />
        }


      </div>
    </>
  )
}

export default EditArticle